import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';

import LiveForm from '@/components/LiveForm';
import LiveFormV2 from '@/components/LiveFormV2';
import ListLive from '@/components/ListLive';
import CalendarLives from '../components/components/CalendarLives';
import SendMail from '../components/components/SendMail';
import ExportRegistrant from '../components/ExportRegistrant';

Vue.use(Router);
let addRoute = 'add';
let editRoute = 'edit';
let editLive = 'EditLive';
let exportLive = 'ExportLive';
let exportRoute ="exportList"
let addLive = 'CreateLive';
let componentForm = LiveForm;
let componentExport = ExportRegistrant;
if (window.process.env.HAS_SKIN === 'true') {
  addRoute = 'add-v2';
  editRoute = 'edit-v2';
  editLive = 'EditLiveV2';
  exportLive = 'ExportLiveV2';
  addLive = 'CreateLiveV2';
  componentForm = LiveFormV2;
}
const router = new Router({
  routes: [
    {
      path: '/liste-lives/live/list',
      name: 'ListLive',
      component: ListLive,
    },
    {
      path: '/liste-lives/live/' + addRoute,
      name: addLive,
      component: componentForm,
    },
    {
      path: '/liste-lives/live/:id/' + editRoute,
      name: editLive,
      component: componentForm,
      props: route => ({ query: route.params.id }),
    },
    {
      path: '/liste-lives/live/calendar',
      name: 'CalendarLives',
      component: CalendarLives,
    },
    {
      path: '/liste-lives/live/send-mail/:id',
      name: 'mailSendGrid',
      component: SendMail,
    }, {
      path: '/liste-lives/:id/' + exportRoute,
      name: exportLive,
      component: componentExport,
      props: route => ({ query: route.params.id }),
    },
  ],
  mode: 'history',
});
router.beforeEach((routeTo, routeFrom, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js